import React, { useState, useRef, useEffect, useCallback } from 'react'
import { debounce } from 'lodash-es'
// import '@/assets/css/components/summaryValues.css'

import './index.scss'
import { useLocal } from '@/pages/dashboard/utils/customHook'
import { Button } from 'tea-component'

interface SummaryValuesProps {
  summaryList?: Array<{
    name?: string
    avg?: string | number | undefined
    sum?: string | number | undefined
  }>
}

export default function SummaryValues(props: SummaryValuesProps) {
  const { summaryList = [] } = props
  // 单行高度
  const singleRowHeight = 48;
  const { getLocalText } = useLocal()
  // 是否展开
  const [isExpanded, setIsExpanded] = useState(false)
  // 是否显示按钮
  const [isShowToggle, setIsShowToggle] = useState(false)
  // 最大高度
  const [maxHeight, setMaxHeight] = useState(0)
  const tempContent = useRef<any>(null)

  const handleClick = () => {
    setIsExpanded(!isExpanded)
  }

  const autoComputedHeight = useCallback(debounce(() => {
    // 若所需总高度大于单行高度则出现切换按钮
    setIsShowToggle(maxHeight > singleRowHeight)
  }, 1000, { leading: true }), [maxHeight])

  useEffect(() => {
    autoComputedHeight()
    window.addEventListener('resize', autoComputedHeight)

    return () => {
      window.removeEventListener('resize', autoComputedHeight)
    }
  }, [maxHeight])

  useEffect(() => {
    if (tempContent.current) {
      setMaxHeight(tempContent.current.clientHeight)
    }
  }, [tempContent.current, JSON.stringify(summaryList)])

  return (
    <div className="dbd-daily-timezone-zone-cont">
      <div className={isExpanded ? "dateComparison-head-wrap dbd-daily-timezone-zone-wrapHeight" : "dateComparison-head-wrap dbd-daily-timezone-zone-wrap"}>
        {summaryList?.map((item, index) => {
          const { name, avg, sum } = item
          return (
            <div className="dateComparison-head" key={'dateComparison-head' + index}>
              <div className="dateComparison-head-title">
                <span>{name}</span>
              </div>
              <div className="dateComparison-head-num">
                <span>{avg}</span>
                <span>{sum}</span>
              </div>
            </div>
          )
        })}
      </div>
      {/* 只用来渲染后，获取最大的所需高度不参与展示，所以获取高度后删除虚拟 dom */}
      <div className='dbd-db-summary-values-temp dateComparison-head-wrap' ref={tempContent}>
        {summaryList?.map((item, index) => {
          const { name, avg, sum } = item
          return (
            <div className="dateComparison-head" key={'dateComparison-head' + index}>
              <div className="dateComparison-head-title">
                <span>{name}</span>
              </div>
              <div className="dateComparison-head-num">
                <span>{avg}</span>
                <span>{sum}</span>
              </div>
            </div>
          )
        })}
      </div>
      {
        isShowToggle &&(
          <div className={isExpanded ? 'dbd-clock-content-expend-btn' : 'dbd-clock-content-btn'}  onClick={handleClick}>
            <Button type='link'>{getLocalText(isExpanded ? 'daily_by_time_zone_trend_fold' : 'daily_by_time_zone_trend_expand')}</Button>
          </div>
        )
      }
    </div>
  )
}
